import { render } from "./TransactionBody.vue?vue&type=template&id=4af5af5c"
import script from "./TransactionBody.vue?vue&type=script&lang=js"
export * from "./TransactionBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__